import React, { useState, useEffect, useRef } from "react";
import "./AuthorPortalSection.css";

const portalData = [
  {
    id: 1,
    badge: "01",
    title: (
      <>
        <strong>대시보드</strong>에서 한눈에 보는 출간 진행 상황
      </>
    ),
    description: (
      <>
        원고 관리, 로열티 현황, 최근 작업한 파일까지 한눈에<br></br> 볼 수 있는
        저자 전용 대시보드입니다.<br></br> 책 작업과 정산 내역을 한눈에 볼 수
        있도록 지원합니다.
      </>
    ),
    imageUrl: "./images/Author_Portal_Image_1.png",
  },
  {
    id: 2,
    badge: "02",
    title: (
      <>
        투명하고 빠른 <strong>로열티 관리</strong>
      </>
    ),
    description:
      "로열티 페이지에서는 판매 실적에 따른 인세 내역을 투명하게 확인할 수 있습니다.",
    imageUrl: "./images/Author_Portal_Image_2.png",
  },
  {
    id: 3,
    badge: "03",
    title: <strong>커뮤니티</strong>,
    description: (
      <>
        경험과 정보를 자유롭게 나누고 소통할 수 있습니다.<br></br> 네트워킹을
        통해 통찰을 얻고 협업의 기회를<br></br> 넓혀 보세요.
      </>
    ),
    imageUrl: "./images/Author_Portal_Image_3.png",
  },
];

const AuthorPortalSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const intervalRef = useRef(null);
  const totalSlides = portalData.length;

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - 1 + totalSlides) % totalSlides);
    startAutoSlide(); // Reset timer on manual navigation
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % totalSlides);
    startAutoSlide(); // Reset timer on manual navigation
  };

  const startAutoSlide = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % totalSlides);
    }, 8000);
  };

  useEffect(() => {
    startAutoSlide();
    return () => {
      clearInterval(intervalRef.current);
    };
  }, [totalSlides]);

  const currentSlide = portalData[currentIndex];

  return (
    <section className="author-portal-section">
      <h1 className="portal-main-title">
        글이 책이 되는 순간, 가장 든든한 동료가 되어드리겠습니다!
      </h1>
      <p className="portal-subtitle">
        <strong>저자 전용 웹사이트</strong>에서 판매실적과 인세를 쉽고 편리하게
        한눈에 관리하세요.
      </p>

      <div className="portal-slider-wrapper">
        <div className="portal-badge">{currentSlide.badge}</div>

        <div className="portal-slider-viewport">
          <div
            className="portal-slider-track"
            style={{ transform: `translateX(-${currentIndex * 100}%)` }}
          >
            {portalData.map((slide) => (
              <div className="portal-slide" key={slide.id}>
                <div className="portal-image-container">
                  <img
                    src={slide.imageUrl}
                    alt={slide.title}
                    className="portal-image"
                  />
                </div>
                <div className="portal-text-content">
                  <h3 className="portal-slide-title">{slide.title}</h3>
                  <p className="portal-slide-description">
                    {slide.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="portal-navigation">
          <button onClick={handlePrev} className="portal-nav-button">
            ‹
          </button>
          <span>
            {currentIndex + 1} / {totalSlides}
          </span>
          <button onClick={handleNext} className="portal-nav-button">
            ›
          </button>
        </div>
      </div>
    </section>
  );
};

export default AuthorPortalSection;
